module.exports = __webpack_public_path__ + "media/rampe.ed798f3e.mp4";